import React, { useEffect, useState, useRef, useMemo } from 'react'
import { gameSubject, initGame, resetGame, handleMove, move as gameMove } from './Game'
import { useUserData } from '../components/UserDataContext'
import Board from '../components/Board/Board'
import PromotionDialog from '../components/Board/PromotionDialog'
import './app.css'
import styles from '../components/home/Home.module.css';
import { useParams, useNavigate, useLocation } from 'react-router-dom'
import { doc, updateDoc, deleteDoc, getDoc, arrayUnion, deleteField } from "firebase/firestore";
import { db, auth } from '../components/Login/firebase-config'
import { signInAnonymously, updateProfile } from 'firebase/auth'
import { chess as chess2 } from "./Game"
import GlobeSpinner from '../components/GlobeSpinner'
export let timeoutt=false;

// Themed full-page status panel so loading/error states match the site
// instead of rendering as bare text on the page background.
function StatusScreen({ spinner, children }) {
  return (
    <div style={{ display: 'flex', justifyContent: 'center', padding: '60px 16px' }}>
      <div style={{ background: '#162060', border: '3px solid #2a3a8c', borderRadius: 8, padding: '32px 24px', maxWidth: 380, width: '100%', boxSizing: 'border-box', boxShadow: '3px 4px 0px #0a1040', textAlign: 'center', color: '#c0ccff', fontFamily: "'Space Grotesk', sans-serif", lineHeight: 1.6 }}>
        {spinner && <div style={{ marginBottom: 12 }}><GlobeSpinner size={60} /></div>}
        {children}
      </div>
    </div>
  );
}

function GameApp() {
  const { id } = useParams();
  const location = useLocation();
  const { refreshData, authLoading } = useUserData();
  const localLevel = location.state?.level || null;
  const localSide = location.state?.side || 'w';
  const inviteDocId = location.state?.inviteDocId || null;

  const [fen, setFen] = useState('start');
  const [isGameOver, setIsGameOver] = useState()
  const [result, setResult] = useState()
  const [position, setPosition] = useState()
  const [initResult, setInitResult] = useState(null)
  const [loading, setLoading] = useState(true)
  const [status, setStatus] = useState('')
  const [game, setGame] = useState({})

  const inviteRef = useRef(inviteDocId);
  const statusRef = useRef('');

  // Board width: on mobile fill the viewport with 16px margins; on desktop
  // subtract the chat panel (260px) + gap (16px) when it's visible so the
  // JS-computed size never exceeds the CSS container width.
  const boardCalcWidth = useMemo(() => ({ screenWidth, screenHeight }) => {
    if (screenWidth <= 768) return Math.min(screenWidth - 32, 500);
    // Local games show the moves panel; online games show chat once ready.
    const chatOffset = id === 'local' || status === 'ready' ? 276 : 0;
    return Math.min(700, screenHeight - 200, screenWidth - 48 - chatOffset);
  }, [id, status]);

  useEffect(() => { statusRef.current = status; }, [status]);

  // Cleanup: delete invite if creator leaves while still waiting
  useEffect(() => {
    inviteRef.current = inviteDocId;
    if (!inviteDocId) return;
    return () => {
      if (inviteRef.current && statusRef.current !== 'ready') {
        deleteDoc(doc(db, 'gameInvites', inviteRef.current)).catch(() => {});
      }
    };
  }, [inviteDocId]);
  const [winner, setWinner] = useState(null)
  const [pendingPromotion, setPendingPromotion] = useState(null)
  const [tick, setTick] = useState(0)

  const [resignConfirm, setResignConfirm] = useState(false);
  const [flipped, setFlipped] = useState(false);
  const [chatInput, setChatInput] = useState('');
  const movesEndRef = useRef(null);
  const [showGuestJoin, setShowGuestJoin] = useState(false);
  const [guestName, setGuestName] = useState('');
  const [guestReady, setGuestReady] = useState(false);
  const chatEndRef = useRef(null);
  const navigate = useNavigate()
  const sharebleLink = window.location.href

  useEffect(() => {
    // Firebase restores the session asynchronously on a fresh page load;
    // until it resolves, auth.currentUser is null and a logged-in user
    // opening a game link directly would be misrouted to the guest flow.
    if (authLoading) return;
    let subscribe
    let cancelled = false
    let retryTimer = null
    async function init() {
      if (cancelled) return;
      timeoutt = false;

      // Unauthenticated visitor on a link game — show guest join prompt
      if (id !== 'local' && !auth.currentUser) {
        try {
          const snap = await getDoc(doc(db, 'games', id));
          if (!snap.exists()) { setInitResult('notfound'); setLoading(false); return; }
          const data = snap.data();
          if (data.game?.status === 'waiting' && data.game?.members?.length === 1) {
            // Guests may only join unrated link games; rated games need an account
            if (data.isRated === false) {
              setShowGuestJoin(true); setLoading(false); return;
            }
            setInitResult('signin'); setLoading(false); return;
          }
        } catch (_) {}
        setInitResult('notfound'); setLoading(false); return;
      }

      let res
      try {
        res = await initGame(
          id !== 'local' ? doc(db, `games/${id}`) : null,
          id === 'local' ? { level: localLevel, side: localSide } : null
        );
      } catch (e) {
        console.error('Game init failed:', e);
        setInitResult('error');
        setLoading(false);
        return;
      }
      if (cancelled) return;
      setInitResult(res)
      setLoading(false)
      if (res === 'notfound' || res === 'intruder') return;
      if (gameSubject) {
        subscribe = gameSubject.subscribe((game) => {
          setFen(game.fen);
          setIsGameOver(game.isGameOver || !!game.winner);
          if (game.winner) setWinner(game.winner);
          if (id === 'local' && game.isGameOver) {
            setWinner(chess2.isCheckmate() ? (chess2.turn() === 'w' ? 'Black' : 'White') : 'Draw');
          }
          setResult(game.result);
          if(id==='local')
            setPosition(localSide);
          else
            setPosition(game.position);
          if(id!=='local') {
            setStatus(game.game.status);
            if (game.game.status === 'ready') inviteRef.current = null;
          }
          if (game.pendingPromotion) {
            setPendingPromotion(game.pendingPromotion);
          } else {
            setPendingPromotion(null);
          }

          setGame(game);
        });
      }
      else{
        retryTimer = setTimeout(init, 1000);
        return;
      }

      // Register this game in the user's games list (after subscribe is active so we don't block moves)
      if (id !== 'local' && res !== 'notfound' && res !== 'intruder' && auth.currentUser) {
        try {
          const userDocRef = doc(db, 'backenddata', auth.currentUser.uid);
          const snap = await getDoc(userDocRef);
          const userGames = snap.data()?.games || [];
          if (!userGames.includes(id)) {
            await updateDoc(userDocRef, { games: arrayUnion(id) });
            refreshData();
          }
        } catch (e) { /* ignore */ }
      }
    }
    init()
    return () => {
      cancelled = true
      if (retryTimer) clearTimeout(retryTimer)
      if (subscribe) subscribe.unsubscribe()
    }
  }, [id, guestReady, authLoading])

  // Display tick: re-render every 100ms so the clock display counts down smoothly. No state mutation.
  useEffect(() => {
    if (status !== 'ready' || isGameOver || !game.turnStartedAt) return;
    const timer = setInterval(() => setTick(t => (t + 1) % 100000), 100);
    return () => clearInterval(timer);
  }, [status, isGameOver, game.turnStartedAt]);

  // Compute the displayed clock values from Firestore state + wall-clock, on every render.
  // Current turn is read from the Firestore FEN so the local post-move chess state can't skew the display.
  const computeTimes = () => {
    if (id === 'local' || !game.member) return { time1: 0, time2: 0 };
    const fallback = game.member.time || 0;
    const storedW = typeof game.whiteTime === 'number' ? game.whiteTime : fallback;
    const storedB = typeof game.blackTime === 'number' ? game.blackTime : fallback;
    let dispW = storedW, dispB = storedB;
    if (game.turnStartedAt && status === 'ready' && !isGameOver) {
      const fen = game.fen && game.fen !== 'start' ? game.fen : null;
      const turn = fen ? fen.split(' ')[1] : 'w';
      const elapsed = (Date.now() - game.turnStartedAt) / 1000;
      if (turn === 'w') dispW = Math.max(0, storedW - elapsed);
      else dispB = Math.max(0, storedB - elapsed);
    }
    return {
      time1: game.member.piece === 'w' ? dispW : dispB,
      time2: game.member.piece === 'w' ? dispB : dispW,
    };
  };
  const { time1, time2 } = computeTimes();


useEffect(() => {
  if (!result) return;
  if (id === 'local') return;

  result.then(resolvedResult => {
    let winnerName = null;
    if (resolvedResult.includes('WHITE')) {
      winnerName = game.oponent?.piece === 'w' ? game.oponent.name : game.member?.name;
      setWinner(winnerName);
    } else if (resolvedResult.includes('BLACK')) {
      winnerName = game.oponent?.piece === 'b' ? game.oponent.name : game.member?.name;
      setWinner(winnerName);
    } else if (!timeoutt) {
      winnerName = 'Draw';
      setWinner('Draw');
    }

    if (winnerName) {
      const reason = resolvedResult.includes('WHITE') || resolvedResult.includes('BLACK')
        ? 'checkmate' : 'draw';
      applyElo(id, reason);
    }
  });
}, [result]);

useEffect(() => {
  if (id === 'local' || timeoutt || isGameOver || status !== 'ready' || !game.turnStartedAt || !game.member) return;
  const fallback = game.member.time || 0;
  const storedW = typeof game.whiteTime === 'number' ? game.whiteTime : fallback;
  const storedB = typeof game.blackTime === 'number' ? game.blackTime : fallback;
  const fen = game.fen && game.fen !== 'start' ? game.fen : null;
  const turn = fen ? fen.split(' ')[1] : 'w';
  const elapsed = (Date.now() - game.turnStartedAt) / 1000;
  const currentStored = turn === 'w' ? storedW : storedB;
  if (currentStored - elapsed <= 0) {
    timeoutt = true;
    const winnerName = game.member.piece === turn ? game.oponent?.name : game.member.name;
    if (winnerName) {
      setWinner(winnerName);
      applyElo(id, 'timeout');
    }
  }
}, [tick]);

  const chatMessages = Array.isArray(game.chat) ? game.chat : [];

  useEffect(() => {
    chatEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [chatMessages.length]);

  const localMoves = id === 'local' ? chess2.history() : [];

  useEffect(() => {
    movesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [localMoves.length]);

  async function handleLocalRestart() {
    await resetGame();
    setWinner(null);
  }

  async function handleGuestJoin() {
    const name = guestName.trim();
    if (!name) return;
    setLoading(true);
    setShowGuestJoin(false);
    try {
      const { user } = await signInAnonymously(auth);
      await updateProfile(user, { displayName: name });
    } catch (e) { console.error('Guest sign-in failed:', e); setLoading(false); return; }
    setGuestReady(true);
  }

  async function applyElo(gameId, reason) {
    try {
      const currentUser = auth.currentUser;
      if (!currentUser) return;
      const token = await currentUser.getIdToken();
      await fetch('/.netlify/functions/apply-elo', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
        body: JSON.stringify({ gameId, reason }),
      });
      refreshData();
    } catch (e) {
      console.error('Elo apply error:', e);
    }
  }

  function handleResign() {
    const opponentName = game.oponent?.name;
    if (!opponentName) return;
    setResignConfirm(false);
    setIsGameOver(true);
    setWinner(opponentName);
    applyElo(id, 'resign');
  }

  async function handleOfferDraw() {
    if (!game.member || !auth.currentUser) return;
    try {
      await updateDoc(doc(db, 'games', id), {
        drawOffer: { byUid: auth.currentUser.uid, byName: game.member.name },
      });
    } catch (_) {}
  }

  async function handleAcceptDraw() {
    setIsGameOver(true);
    setWinner('Draw');
    applyElo(id, 'agreed_draw');
  }

  async function handleDeclineDraw() {
    try {
      await updateDoc(doc(db, 'games', id), { drawOffer: deleteField() });
    } catch (_) {}
  }

  async function copyToClipboard() {
    await navigator.clipboard.writeText(sharebleLink)
  }

  const sendMessage = async (e) => {
    e.preventDefault();
    const text = chatInput.trim();
    if (!text || !game.member || !auth.currentUser) return;
    setChatInput('');
    try {
      await updateDoc(doc(db, 'games', id), {
        chat: arrayUnion({ uid: auth.currentUser.uid, name: game.member.name, text, ts: Date.now() })
      });
    } catch (_) {}
  };
  if (showGuestJoin) {
    return (
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: '60vh', padding: '40px 16px' }}>
        <div style={{ background: '#162060', border: '3px solid #2a3a8c', borderRadius: '8px', padding: '32px 24px', width: '100%', maxWidth: '360px', boxSizing: 'border-box', boxShadow: '3px 4px 0px #0a1040', textAlign: 'center' }}>
          <p style={{ color: '#ffd700', fontFamily: "'Press Start 2P', cursive", fontSize: '10px', marginBottom: '20px', textTransform: 'uppercase', textShadow: '1px 1px 0 #0a1040' }}>Join as Guest</p>
          <input
            value={guestName}
            onChange={e => setGuestName(e.target.value)}
            onKeyDown={e => e.key === 'Enter' && handleGuestJoin()}
            placeholder="Enter your name"
            maxLength={20}
            style={{ width: '100%', background: '#0d1654', border: '2px solid #2a3a8c', borderRadius: '4px', color: '#e8eeff', padding: '10px 12px', fontFamily: "'JetBrains Mono', monospace", fontSize: '14px', outline: 'none', boxSizing: 'border-box', marginBottom: '16px' }}
          />
          <button onClick={handleGuestJoin} disabled={!guestName.trim()} style={{ width: '100%', padding: '12px', fontSize: '14px', background: guestName.trim() ? '#ffd700' : '#2a3a8c', color: guestName.trim() ? '#0a1040' : '#8899cc', border: 'none', borderRadius: '4px', cursor: guestName.trim() ? 'pointer' : 'not-allowed', fontFamily: "'Press Start 2P', cursive", fontWeight: 700, marginBottom: '12px' }}>
            Play as Guest
          </button>
          <p style={{ color: '#8899cc', fontSize: '12px' }}>or <a href="/login" style={{ color: '#8899cc' }}>sign in</a> for rated games</p>
        </div>
      </div>
    );
  }

  if (loading) {
    return (
      <StatusScreen spinner>
        <p>Loading game&hellip;</p>
      </StatusScreen>
    )
  }
  if (initResult === 'notfound') {
    return (
      <StatusScreen>
        <p style={{ marginBottom: 16 }}>Game not found. It may have ended or the link is wrong.</p>
        <button className={styles.custombutton} onClick={() => navigate('/play')}>Start a new game</button>
      </StatusScreen>
    )
  }

  if (initResult === 'intruder') {
    return (
      <StatusScreen>
        <p style={{ marginBottom: 16 }}>This game already has two players.</p>
        <button className={styles.custombutton} onClick={() => navigate('/play')}>Start your own game</button>
      </StatusScreen>
    )
  }

  if (initResult === 'signin') {
    return (
      <StatusScreen>
        <p style={{ marginBottom: 16 }}>This is a rated game &mdash; you need an account to join.</p>
        <button className={styles.custombutton} onClick={() => navigate('/login')}>Sign in</button>
      </StatusScreen>
    )
  }

  if (initResult === 'error') {
    return (
      <StatusScreen>
        <p style={{ marginBottom: 16 }}>Something went wrong loading this game.</p>
        <button className={styles.custombutton} onClick={() => window.location.reload()}>Reload</button>
      </StatusScreen>
    )
  }
  return (<div>
    <div className="app-container">
      
      {isGameOver && (
        <h2 >
          GAME OVER
          <button className={styles.custombutton}
          onClick={async () => {
            await resetGame()
            navigate("/play");
          }}>
            <span> NEW GAME</span>
          </button>
          {id!=='local' && (
  <button className={styles.custombutton} onClick={() => navigate(`/analysis/${id}`)}>
    <span>ANALYSE</span>
  </button>
)}
          {id==='local' && (
  <button className={styles.custombutton} onClick={() => navigate('/analysis', { state: { pgn: chess2.pgn() } })}>
    <span>ANALYSE</span>
  </button>
)}
{winner && <span>{winner === 'Draw' ? 'Draw!' : `${winner} wins !`}</span>}
        </h2>
      )}      

      <div className={id === 'local' || status === 'ready' ? 'game-with-chat' : ''}>
        <div className="board-container">
        {id === 'local' && localLevel && (
          <span className="tag is-link" style={{ marginBottom: '10px', display: 'flex', alignItems: 'center', gap: '8px' }}>
            <span>{localLevel.icon}</span>
            <span>{localLevel.label}{localLevel.elo ? ` (~${localLevel.elo})` : ' (MAX)'}</span>
            {!isGameOver && chess2.turn() !== localSide && <span style={{opacity:0.6}}>thinking…</span>}
          </span>
        )}
        {game.oponent && game.oponent.name && <span className={`tag is-link${game.oponent.piece===chess2.turn()&&status==='ready'&&!isGameOver?' active-turn':''}`}>{game.oponent.name}{game.oponent.piece===chess2.turn()&&`'s turn`} {Math.floor(Math.max(0,time2)/60)}:{String(Math.floor(Math.max(0,time2))%60).padStart(2,'0')}</span>}
        <Board
          chess={chess2}
          currFen={fen}
          side={(position === 'b') !== flipped ? 'black' : 'white'}
          customOnDrop={handleMove}
          draggable={!isGameOver}
          sounds={true}
          premoves={true}
          calcWidth={boardCalcWidth}
        />
        {pendingPromotion && (id === 'local' || pendingPromotion.color === game.member?.piece) && (
          <PromotionDialog
            color={pendingPromotion.color}
            onSelect={(piece) => {
              gameMove(pendingPromotion.from, pendingPromotion.to, piece);
              setPendingPromotion(null);
            }}
          />
        )}

        {id !== 'local' && status === 'ready' && !isGameOver && game.member && (
          <div className="game-actions">
            {game.drawOffer && game.drawOffer.byUid !== auth.currentUser?.uid ? (
              <>
                <span className="draw-offer-msg">{game.drawOffer.byName} offers a draw</span>
                <button className="action-btn draw-btn" onClick={handleAcceptDraw}>Accept</button>
                <button className="action-btn decline-btn" onClick={handleDeclineDraw}>Decline</button>
              </>
            ) : game.drawOffer?.byUid === auth.currentUser?.uid ? (
              <span className="draw-offer-msg">Draw offered…</span>
            ) : resignConfirm ? (
              <>
                <span className="draw-offer-msg">Resign?</span>
                <button className="action-btn resign-btn" onClick={handleResign}>Yes</button>
                <button className="action-btn decline-btn" onClick={() => setResignConfirm(false)}>No</button>
              </>
            ) : (
              <>
                <button className="action-btn draw-btn" onClick={handleOfferDraw}>Offer Draw</button>
                <button className="action-btn resign-btn" onClick={() => setResignConfirm(true)}>Resign</button>
              </>
            )}
          </div>
        )}

        {game.member && game.member.name && <span className={`tag is-link${game.member.piece===chess2.turn()&&status==='ready'&&!isGameOver?' active-turn':''}`}>{game.member.name+'   '}{game.member.piece===chess2.turn()&&' - your turn  '}{Math.floor(Math.max(0,time1)/60)}:{String(Math.floor(Math.max(0,time1))%60).padStart(2,'0')}</span>}
      </div>
        {id === 'local' && (
          <div className="chat-panel">
            <div className="chat-header">Moves</div>
            <div className="chat-messages" style={{ fontFamily: "'JetBrains Mono', monospace", fontSize: '13px', color: '#c0ccff', gap: '4px' }}>
              {localMoves.length === 0 ? (
                <span style={{ color: '#8899cc', fontSize: '12px' }}>No moves yet &mdash; you have the {position === 'b' ? 'black' : 'white'} pieces.</span>
              ) : (
                Array.from({ length: Math.ceil(localMoves.length / 2) }, (_, row) => (
                  <div key={row} style={{ display: 'flex', gap: '10px' }}>
                    <span style={{ color: '#8899cc', width: '26px', flexShrink: 0, textAlign: 'right' }}>{row + 1}.</span>
                    <span style={{ width: '64px' }}>{localMoves[row * 2]}</span>
                    <span>{localMoves[row * 2 + 1] || ''}</span>
                  </div>
                ))
              )}
              <div ref={movesEndRef} />
            </div>
            <div style={{ display: 'flex', gap: '8px', padding: '10px', borderTop: '2px solid #2a3a8c' }}>
              <button className="action-btn draw-btn" onClick={() => setFlipped(f => !f)}>Flip board</button>
              <button className="action-btn resign-btn" onClick={handleLocalRestart}>Restart</button>
            </div>
          </div>
        )}
        {id !== 'local' && status === 'ready' && (
          <div className="chat-panel">
            <div className="chat-header">Chat</div>
            <div className="chat-messages">
              {chatMessages.map((msg, i) => (
                <div key={i} className={`chat-msg${msg.uid === auth.currentUser?.uid ? ' mine' : ''}`}>
                  <span className="chat-msg-name">{msg.name}</span>
                  <span className="chat-msg-text">{msg.text}</span>
                </div>
              ))}
              <div ref={chatEndRef} />
            </div>
            <form className="chat-form" onSubmit={sendMessage}>
              <input
                className="chat-input"
                value={chatInput}
                onChange={e => setChatInput(e.target.value)}
                placeholder="Message..."
                maxLength={200}
              />
              <button type="submit" className="chat-send">Send</button>
            </form>
          </div>
        )}
      </div>
      {status === 'waiting' && (
  <div style={{ fontSize:"16px", marginLeft: "18px" }} className="notification is-link share-game">
    {inviteDocId ? (
      <>
        <strong>Waiting for opponent to accept...</strong>
        <br />
        <span style={{ fontSize: '13px', opacity: 0.7 }}>Challenge sent! They'll see a notification on their screen.</span>
      </>
    ) : (
      <>
        <strong>Share this game to continue</strong>
        <br />
        <br />
        <div style={{ display: "flex", alignItems: "center" }}>
          <input
            style={{ fontFamily: "'JetBrains Mono', monospace", marginRight: "8px" }}
            type="text"
            name=""
            id=""
            className="input"
            readOnly
            value={sharebleLink}
          />
          <button className={styles.custombutton} onClick={copyToClipboard}>Copy</button>
        </div>
      </>
    )}
  </div>
)}


    </div></div>
  )
}

export default GameApp
